import { AnaColumn } from "../forms-template.service";

export const StatoEstero: AnaColumn[] = [
    {
      itemType: "group", colCount: "2", colSpan: "2", data: [
        {
          colVisible:false, type: 'campo', disableOnUpdate: true, dataField: "id", dataType: "string", caption: "ID",
  
        },
        {
          type: 'campo', dataField: "descrizione", dataType: "", caption: "DENOMINAZIONE",
          validation: [{ type: "required", message: "Campo Obbligatorio" }]
        },
  
        { type: 'campo', dataField: "iso", dataType: "", caption: "ISO" },
        { type: 'campo', dataField: "iso4", dataType: "", caption: "ISTAT" },
      ]
    },
  ]